import TermsAndConditionsModal from './styled';

export default TermsAndConditionsModal;
